export const WATCHLIST_MESSAGES = {
  NOT_FOUND: 'No watchlists records were found',
};


// WEBPACK FOOTER //
// ./src/constants/watchListMessages.js